import { useState, useEffect, RefObject } from "react";

interface ScrollProgressBarProps {
  containerRef: RefObject<HTMLElement>;
}

export const ScrollProgressBar = ({ containerRef }: ScrollProgressBarProps) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;

    const update = () => {
      const { scrollTop, scrollHeight, clientHeight } = el;
      const max = scrollHeight - clientHeight;
      setProgress(max > 0 ? (scrollTop / max) * 100 : 0);
    };

    el.addEventListener("scroll", update);
    update();
    return () => el.removeEventListener("scroll", update);
  }, [containerRef]);

  if (progress === 0) return null;

  return (
    <div className="absolute top-0 left-0 right-0 h-1 z-20 bg-muted/50">
      <div
        className="h-full bg-gradient-to-r from-primary/60 via-primary to-primary/60 transition-[width] duration-150 ease-out rounded-r-full"
        style={{ width: `${progress}%` }}
      />
    </div>
  );
};
